<ng-container *ngIf="visitDetails else visitDetailsLoadingError">
  <div class="container-narrow my-5">
    <div class="row mb-4 ms-1 justify-content-center">
      <p class="subtitle pre-wrap text-center"
         [innerHTML]="'BOOKING-PART.PAYMENT-PENDING.DESCRIPTION' | translate"></p>
    </div>
    <div class="row mb-4">
      <div class="col-12 d-flex align-items-top justify-content-center">
        <button class="btn btn-cta btn-lg px-3 px-sm-5 shadow-sm fw-bold"
                (click)="goToPayment()">
          <span>
            {{ 'BOOKING-PART.PAYMENT-PENDING.BUTTON-PAY' | translate: {timeLeft: countdownRedirectInSeconds} }}
          </span>
        </button>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-5 col-offset-1">
        <img src="assets/img/da-vinci-logo-gray.svg"
             class="da-vinci-logo img-fluid"
             alt="DaVinci Logo">
      </div>
    </div>
  </div>
</ng-container>

<ng-template #visitDetailsLoadingError>
  <div class="container-narrow my-5">
    <div class="row mt-5">
      <div class="col-12">
        <h1 class="h3 fw-bolder"
            [translate]="'BOOKING-PART.COMMON-ERRORS.VISIT-DETAILS.TITLE'"></h1>
        <p [translate]="'BOOKING-PART.COMMON-ERRORS.VISIT-DETAILS.DESCRIPTION'"
           class="pre-wrap"></p>
      </div>
    </div>
  </div>
</ng-template>
